<template>
  <qx-card title="列表">
    <LogRightDialog ref="logRightDialog" busiCode="300000" />
    <section slot="titleRight">
      <qx-permpisions permpisions="1001010501">
        <ExportBtn
          :len="tableData.data.length"
          queryUrl="orderAgingBO.ajax?cmd=queryOrderAgingList"
          :params="fullSearchData"
          bizName="时效罚款数据导出"
          bizCode="exp100011"
          :excelKeys="excelKeys"
          :excelLables="excelLables"
        />
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox" ref="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          :height="tableHeight"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!-- <el-table-column type="selection" width="55" /> -->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <el-table-column
            v-for="(item, index, key) in tableData.title"
            :key="key"
            :prop="item.prop"
            :label="item.label"
            :sortable="item.sortable"
            :filters="item.filters"
            :filter-method="item.filterHandler"
            :min-width="item.minW"
            :width="item.w"
          >
            <section slot-scope="scope">
              <section v-if="scope.column.property === 'orderId'">
                <span v-if="scope.row.orderType === 1">固定：</span>
                <span v-else-if="scope.row.orderType === 2">
                  <span v-if="scope.row.sourceFlag === 14">城配：</span>
                  <span v-else>临时：</span>
                </span>
                <span v-else>三方：</span>
                <span class="primary cur" @click="toOrderDetail(scope.row)">{{
                  scope.row[scope.column.property]
                }}</span>
              </section>
              <section v-else-if="scope.column.property === 'sourceRegionName'">
                <span
                  :class="{
                    primary: scope.row.sourceId !== -1,
                    cur: scope.row.sourceId !== -1,
                  }"
                  @click="toLineDetail(scope.row)"
                  >{{
                    `${scope.row.sourceRegionName.replace(
                      '市',
                      ''
                    )}-${scope.row.desRegionName.replace('市', '')}`
                  }}</span
                >
              </section>
              <section
                v-else-if="scope.column.property === 'orderLine'"
                @click="showLineDetail(scope.row)"
              >
                <span class="primary cur">{{
                  scope.row[scope.column.property]
                }}</span>
              </section>
              <section v-else>{{ scope.row[scope.column.property] }}</section>
            </section>
          </el-table-column>
          <!-- 常规列表项 end -->
          <!-- 操作按钮 -->
          <el-table-column
            prop="control"
            label="操作"
            width="120"
            fixed="right"
          >
            <template slot-scope="scope">
              <section>
                <qx-permpisions permpisions>
                  <span class="primary cur" @click="toHandle(scope.row)"
                    >前往处理</span
                  >
                </qx-permpisions>
                <qx-permpisions permpisions>
                  <span class="primary cur" @click="showLog(scope.row.orderId)"
                    >日志</span
                  >
                </qx-permpisions>
              </section>
            </template>
          </el-table-column>
          <!-- 操作按钮 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import ExportBtn from 'components/exportBtn';
import LogRightDialog from 'components/logRightDialog';
import {
  orderTimeList,
} from 'api/operate';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    ExportBtn,
    LogRightDialog,
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          {
            prop: 'orderId',
            label: '订单号码',
          },
          {
            prop: 'companyName',
            label: '客户名称',
          },
          {
            prop: 'sourceRegionName',
            label: '运输线路',
          },
          {
            prop: 'dependTime',
            label: '发车时间',
          },
          {
            prop: 'plateNumber',
            label: '车牌号码',
          },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: orderTimeList,
    toOrderDetail (item) {
      this.jump({
        label: `订单详情-${item.orderId}`,
        url: `/manage/operate/order/deal/orderDetailTab?id=${item.orderId}`,
        full: true,
      });
    },
    toLineDetail (item) {
      if (item.sourceId === -1) {
        return;
      }
      this.jump({
        label: '线路详情',
        url: `/manage/archives/customer/line/detail?id=${item.sourceId}`,
        full: true,
      });
    },
    showLog (id) {
      this.$refs.logRightDialog.show(id);
    },
    toHandle (item) {
      this.jump({
        label: '时效审核处理',
        url: `/manage/operate/order/deal/orderDetailTab?tar=1&id=${item.orderId}&isHandle=true`,
        full: true,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
</style>
